import React, { useState } from 'react';
import { Box, Typography, Link, Container, TextField, Button } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import './Footer.css';

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement newsletter subscription
    console.log('Subscribe:', email);
  };

  return (
    <Box component="footer" className="footer">
      <Container maxWidth="lg">
        <Box className="footer-sections">
          {/* Newsletter Section */}
          <Box className="footer-section">
            <Typography variant="h6" className="footer-title">
              Newsletter
            </Typography>
            <Typography variant="body2" className="footer-text">
              Want to stay up to date with the latest news and updates? Sign up for our newsletter!
            </Typography>
            <Box component="form" onSubmit={handleSubscribe} className="newsletter-form">
              <TextField
                size="small"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="newsletter-input"
              />
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                className="newsletter-button"
              >
                Subscribe
              </Button>
            </Box>
          </Box>

          {/* Schedule Section */}
          <Box className="footer-section">
            <Typography variant="h6" className="footer-title" sx={{ mt: 3 }}>
              Address
            </Typography>
            <Typography variant="body2" className="footer-text">
              CAP House, 9 Long Ln, City of London
            </Typography>
            <Typography variant="body2" className="footer-text">
              London EC1A 9HA
            </Typography>
          </Box>

          {/* Follow Us Section */}
          <Box className="footer-section">
            <Typography variant="h6" className="footer-title">
              Follow us
            </Typography>
            <Box className="social-links">
              <Link
                href="https://twitter.com/appvia_io"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <TwitterIcon />
              </Link>
              <Link
                href="https://github.com/appvia"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <GitHubIcon />
              </Link>
              <Link
                href="https://linkedin.com/company/appvia"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <LinkedInIcon />
              </Link>
            </Box>
            <Typography variant="h6" className="footer-title">
              Contact
            </Typography>
            <Box className="contact-links">
              <Link
                href="tel:+442035982750"
                className="contact-link"
              >
                <PhoneIcon className="contact-icon" />
                <Typography variant="body2" className="footer-text">
                  +44 203 598 2750
                </Typography>
              </Link>
              <Link
                href="mailto:info@appvia.io"
                className="contact-link"
              >
                <EmailIcon className="contact-icon" />
                <Typography variant="body2" className="footer-text">
                  info@appvia.io
                </Typography>
              </Link>
            </Box>
          </Box>
        </Box>

        {/* Copyright Section */}
        <Box className="copyright-section">
          <Typography variant="body2" className="copyright-text">
            © {new Date().getFullYear()} Appvia. All rights reserved.
          </Typography>
          <Box className="footer-links">
            <Link
              href="https://appvia.io/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Privacy Policy
            </Link>
            <Link
              href="https://appvia.io/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 